// if document is changed then this function will be called to update the cart drawer 
function formatMoney(cents, format) {
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);
  
    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) {
        return 0;
      }
  
      number = (number / 100.0).toFixed(precision);
  
      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }
  
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  };
  
 let cartDrawer = document.querySelector('#cart-drawer');
 let cartDrawerClose = document.querySelectorAll('#close-cart');
  var loaderSkeleton = document.querySelector('.loader__skeleton');
 let body = document.body;
  
  // This function is used to fetch the cart drawer data from a end point i have created in the template with no layout containing the liquid code to append. 
  async function refreshCartDrawer() {
    loaderSkeleton.style.display = 'block';
    fetch('/?view=cart-drawer')
      .then(function (response) {
        return response.text();
      })
      .then(function (cartData) {
        document.querySelector('.cart-drawer__body').innerHTML = cartData;
        loaderSkeleton.style.display = 'none';
        
        const swiper = new Swiper('.upsell-slider', {
          // Optional parameters
          loop: true,
          slidesPerView: 1.7,
          spaceBetween: 15,
          
          // Navigation arrows
        });
    
        setTimeout(function(){
          console.log("I am launched");
        },1000);

        let upsellAtc = document.querySelectorAll('.upsell-atc');

        upsellAtc.forEach(element => {
          element.onclick = function(e){
            e.preventDefault();        // prevents the default behavior
            e.stopPropagation();
            var previousElement = e.target.previousElementSibling;
            let variantId = "";
            if (previousElement) {
                console.log(previousElement);
                variantId =previousElement.querySelector('select').value;
            }
            
            if (!variantId) {
              console.error("Product variant ID is missing.");
              return;
          }

          // Define the data to send in the request (product ID and quantity)
          var postData = {
              "id": variantId,
              "quantity": 1  // You can change this value or make it dynamic based on user input
          };

          // Create the AJAX request
          var xhr = new XMLHttpRequest();
          xhr.open('POST', '/cart/add.js', true);
          xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
          xhr.onreadystatechange = function() {
              if (xhr.readyState == 4 && xhr.status == 200) {
                  // Product added successfully
                  var response = JSON.parse(xhr.responseText);
                  console.log(response);
                  setTimeout(function() {
                    refreshCartDrawer()
                }, 500);

                  // Here, you can redirect to cart, show a message or whatever you like
                  // Example: window.location.href = '/cart';
              } else if (xhr.readyState == 4) {
                  // Error occurred
                  console.error("Failed to add product to cart.");
              }
          };
          xhr.send(JSON.stringify(postData));

          }
        })
  
        // Append a new div element with data-rebuy-id of "87019" to the last .cart-drawer-upsell__container element
        
        const cartContainers = document.querySelectorAll('.cart-drawer-upsell__container');
        // if cartContainers is empty, return early to prevent error on next line of code 
        if (!cartContainers.length) {
          return;
        }
      
      });

      fetchCartItems(function(cart) {
        console.log(cart.item_count); // This will log the cart data to the console.
       document.querySelector(".cart_total_product").innerHTML = `(${cart.item_count})`; 
       document.querySelector(".cart_drawer_count").innerHTML = `(${cart.item_count})`; 

    });
  }
  
  document.addEventListener("rebuy:cart.change", function () { refreshCartDrawer(Rebuy.Cart.cart); });
  
  async function toggleCartDrawer(isOpen) {
   let cartDrawer = document.querySelector('.cart-drawer');
   let cartDrawerOverlay = document.querySelector('.cart-drawer-overlay');
  
    if (isOpen) {
  
      setTimeout(() => {
        refreshCartDrawer();
        cartDrawer.style.transform = 'translateX(0)';
        cartDrawerOverlay.style.display = 'block';
        body.classList.add('cart-drawer-open');
  
      }, 300);
    } else {
      cartDrawer.style.transform = 'translateX(100%)';
      cartDrawerOverlay.style.display = 'none';
      body.classList.remove('cart-drawer-open');
    }
  

  }
  
  function fetchCartItems(callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', true);
    xhr.onreadystatechange = function() {
        if (xhr.readyState == 4 && xhr.status == 200) {
            var cartData = JSON.parse(xhr.responseText);
            callback(cartData);
        }
    };
    xhr.send();
}

// Usage:

  
  const toggleCartDrawerButtons = document.querySelectorAll('[toggle-cart-drawer]');
  toggleCartDrawerButtons.forEach((button) => {
    button.addEventListener('click', () => toggleCartDrawer(true));
  });
  
  const elementsToTriggerCartDrawer = '.product-form__submit';
  const elementsToTrigger = document.querySelectorAll(elementsToTriggerCartDrawer);
  elementsToTrigger.forEach((element) => {
    element.addEventListener('click', () => {
      refreshCartDrawer();
      setTimeout(function() {
        toggleCartDrawer(true);

    }, 500);
    });
  });
  
  /// Function for close the cart drawer 
  cartDrawerClose.forEach(function (button) {
    button.addEventListener('click', function () {
      cartDrawer.style.transform = 'translateX(100%)';
      document.querySelector('.cart-drawer-overlay').style.display = 'none';
      body.classList.remove('cart-drawer-open');
    });
  });
  
  document.querySelector('.cart-drawer-overlay').addEventListener('click', function () {
    cartDrawer.style.transform = 'translateX(100%)';
    this.style.display = 'none';
    body.classList.remove('cart-drawer-open');
  });
  
  // // Function on click to add product from quick add to cart drawer
  
  // document.querySelector('body').addEventListener('click', function (e) {
  //   if (e.target.id === ('quick-add') || e.target.classList.contains('product-form--atc-button')) {
  //     refreshCartDrawer();
  //     toggleCartDrawer(true);
  //   }
  // });
  
  // // This function is for updating the quantity for each item in the cart drawer, and it is then calling the updateQunaity function
  
  document.querySelector('.cart-drawer__body').addEventListener('click', function (e) {
    console.log(e.target.classList);
    if (e.target.classList.contains('cart-drawer-quantity__minus')) {
      console.log('minus clicked');
      const cartDrawerQuantityVal = e.target.parentElement.querySelector('.cart-drawer__item-quantity__val');
      const itemId = cartDrawerQuantityVal.getAttribute('data-item-id');
      const quantity = parseInt(cartDrawerQuantityVal.value, 10) - 1;
      if (quantity >= 1) {
        updateCart(itemId, quantity, 'updateItemQty');
      }
    }
    
    if (e.target.classList.contains('cart-drawer__item-delete')) {
      console.log('delete clicked');
      const itemId = e.target.getAttribute('data-item-id');
      updateCart(itemId, 0, 'removeItem')
    }
  
    if (e.target.classList.contains('smart-cart-drawer-upsell-product-add')) {
      e.preventDefault();
      const upsellBtn = e.target;
      const upsellId = upsellBtn.getAttribute('data-varaint');
      const quantity = 1;
      addToCart(upsellId, quantity);
    }
  });


  document.body.addEventListener('click', function(e) {
    // Check if the clicked element or one of its parents has the .cart-drawer-quantity__plus class
    let targetElement = e.target;
    while (targetElement !== null && !targetElement.classList.contains('cart-drawer-quantity__plus')) {
      targetElement = targetElement.parentElement;
    }
  
    // If targetElement is not null, it means we found our element
    if (targetElement) {
      console.log(e.target.classList);
      console.log('plus clicked');
      
      const cartDrawerQuantityVal = targetElement.parentElement.querySelector('.cart-drawer__item-quantity__val');
      const itemId = cartDrawerQuantityVal.getAttribute('data-item-id');
      const quantity = parseInt(cartDrawerQuantityVal.value, 10) + 1;
      updateCart(itemId, quantity, 'updateItemQty');
    }
  });

  document.body.addEventListener('click', function(e) {
    // Check if the clicked element or one of its parents has the .cart-drawer-quantity__plus class
    let targetElement = e.target;
    while (targetElement !== null && !targetElement.classList.contains('cart-drawer-quantity__minus')) {
      targetElement = targetElement.parentElement;
    }
  
    // If targetElement is not null, it means we found our element
    if (targetElement) {
      console.log(e.target.classList);
      console.log('minus clicked');
      
      const cartDrawerQuantityVal = targetElement.parentElement.querySelector('.cart-drawer__item-quantity__val');
      const itemId = cartDrawerQuantityVal.getAttribute('data-item-id');
      const quantity = parseInt(cartDrawerQuantityVal.value, 10) - 1;
      updateCart(itemId, quantity, 'updateItemQty');
    }
  });
  

  // this function handles the update item quanity as well as the remove item from the cart as it takes the type as a parameter
  async function updateCart(itemId, quantity, type) {
    try {
      // Fetch the current cart
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const item = cart.items.find((item) => (item.key == itemId));
  
      // Check if the item is already at the desired quantity for update and return if true
      if (type === 'updateItemQty' && item.quantity === quantity) return;
  
      // Make a request to update or delete the item in the cart 
      let updatedRes;
      if (type === 'updateItemQty') {
        updatedRes = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: itemId,
            quantity: quantity
          })
        });
      } else if (type === 'removeItem') {
        updatedRes = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: itemId,
            quantity: quantity
          })
        });
      }
      const updatedCart = await updatedRes.json();
  
      if (type === 'updateItemQty') {
  
        const updatedItem = updatedCart.items.find((item) => (item.key == itemId));
        const itemPrice = updatedItem.final_line_price;
        const moneyFormat = document.getElementById('cart-drawer').getAttribute('data-money-format');
        const cartDrawerSubtotalPrice = document.querySelector('.cart-drawer-subtotal__price');
        const cartDrawerItemPrice = document.querySelector(`[data-item-id="${itemId}"] .cart-drawer__item-price`);
        cartDrawerSubtotalPrice.innerHTML = formatMoney(updatedCart.total_price, moneyFormat);
        cartDrawerItemPrice.innerHTML = formatMoney(itemPrice, moneyFormat);
  
        refreshCartDrawer();
  
      } else if (type === 'removeItem') {
        loaderSkeleton.style.display = 'block';
        if (cart.items.length === 0) {
          cartDrawer.style.transform = 'translateX(100%)';
          document.querySelector('.cart-drawer-overlay').style.display = 'none';
          body.classList.remove('cart-drawer-open');
          document.querySelector('#cart-drawer__form').remove();
          const emptyState = document.createElement('div');
          emptyState.innerHTML = `
                <div class="cart-drawer__empty">
                  <p class="cart-drawer__empty-text"> Your Basket is empty </p>
                  <span> Add your favorite items to your cart.</span>
                  <a class="cart-drawer__empty-btn" href="/"> Shop Now <a>
                </div>`;
          document.querySelector('.cart-drawer .cart-drawer__body').appendChild(emptyState);
        } else {
          const removeItem = document.querySelector('.cart-drawer__item[data-item-id="' + itemId + '"]');
  
          loaderSkeleton.style.display = 'none';
  
          removeItem.remove();
          await refreshCartDrawer();
        }
      }
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }
  
  var quick_add = document.querySelectorAll('.quick-add__submit');
  
  quick_add.forEach(function(element) {
    // Do something with each element here
    // For example, add a click event listener
    element.addEventListener('click', function() {
      refreshCartDrawer();
      toggleCartDrawer(true);
    });
  });